export default "__VITE_ASSET__Cqs1ibPc__"